import ProtoTypes from 'prop-types';
import Typography from '@mui/material/Typography';


export function BaseBlockTitle(props) {
    const { fontTheme } = props;
    const isLight = fontTheme === 'light';
    const fontColor = isLight ? 'primary.main' : 'customText.white';

    return (
        <Typography
            variant='h1'
            align="center"
            color={fontColor}
            gutterBottom
        >
            {props.value}
        </Typography>
    )
}

export function BaseBlockSubtitle(props) {
    const { fontTheme } = props;
    const isLight = fontTheme === 'light';
    const fontColor = isLight ? 'primary.main' : 'customText.white';

    return (
        <Typography
            variant='h3'
            align="center"
            gutterBottom
            color={fontColor}
        >
            {props.value}
        </Typography>
    )  
}

BaseBlockTitle.propTypes = {
    value: ProtoTypes.string.isRequired,
}

BaseBlockTitle.defaultProps = {
    fontTheme: 'light'
}

BaseBlockSubtitle.propTypes = {
    value: ProtoTypes.string.isRequired,
}

BaseBlockSubtitle.defaultProps = {
    fontTheme: 'light'
}